// Slack connection capabilities for a stored client key.
//
// The endpoint is named by the node catalog (`builder.capabilities_endpoint`); it reports the
// connected workspace, granted scopes and per-operation capability flags.
import { adminRequest } from "./adminRequest";

export const DEFAULT_CAPABILITIES_ENDPOINT = "/admin/slack/capabilities";

/**
 * @param {object} params
 * @param {string} [params.endpoint]
 * @param {string|null} [params.clientId]
 * @param {string} params.key The `clientKey` (stored key name).
 */
export const getNodeCapabilities = async ({
  endpoint = DEFAULT_CAPABILITIES_ENDPOINT,
  clientId = null,
  key = null,
  keyParam = "key",
  clientIdParam = "client_id",
} = {}) => {
  const params = new URLSearchParams();
  if (clientId) params.set(clientIdParam, clientId);
  if (key) params.set(keyParam, key);

  return adminRequest("GET", `${endpoint ?? DEFAULT_CAPABILITIES_ENDPOINT}?${params.toString()}`);
};

/** Backwards-compatible alias. */
export const getSlackCapabilities = getNodeCapabilities;

export default getNodeCapabilities;
